export const environment = {
    production: false,
    baseUrl: 'https://api.booking.funbutler.dev',
    clientAppBaseUrl: 'https://client.booking.funbutler.dev',
    publicAppBaseUrl: 'https://booking.funbutler.dev',
    adminAppBaseUrl: 'https://admin.booking.funbutler.dev',
    crmAppBaseUrl: 'https://crm.booking.funbutler.dev',
    orgBaseUrl: 'https://org.booking.funbutler.dev',
    apiBaseUrl: 'https://api.booking.funbutler.dev',
    webSafeFonts: [
        'Arial',
        'Verdana',
        'Trebuchet MS',
        'Times New Roman',
        'Didot',
        'American Typewriter',
        'Andale Mono',
        'Courier',
        'Bradley Hand',
        'Luminari'
    ],
    stripePublicKey: 'pk_live_51LY6cTF2Iydm81zGCjoE670gy6HXAEAhX06zUNzjphv17gz6Hw2DgKuC44AEodODduUuExWPz1G08uPVRE0Z8heC00TkC9zG7i',
    adyenClientKey: ''
};
